import { Select } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  DAILY_METRIC_FILL_FILTER_ORDER,
  type DailyMetricFillFilter,
} from '../dailyMetricFillFilter'
import { FilterGroup } from './styled'

export interface DailyMetricFillSelectorProps {
  label: string
  value: DailyMetricFillFilter
  onChange: (value: DailyMetricFillFilter) => void
}

const DailyMetricFillSelector = ({ label, value, onChange }: DailyMetricFillSelectorProps) => {
  const { t } = useTranslation()

  const options = useMemo(() => {
    const labels: Record<DailyMetricFillFilter, string> = {
      all: t('admin_router.dashboard.metric_fill_all'),
      complete: t('admin_router.dashboard.metric_fill_complete'),
      empty: t('admin_router.dashboard.metric_fill_empty'),
    }
    return DAILY_METRIC_FILL_FILTER_ORDER.map(filterValue => ({
      value: filterValue,
      label: labels[filterValue],
    }))
  }, [t])

  return (
    <FilterGroup>
      <span className="filter-label">{label}</span>
      <Select
        style={{ minWidth: 140 }}
        aria-label={label}
        options={options}
        value={value}
        onChange={v => onChange(v as DailyMetricFillFilter)}
      />
    </FilterGroup>
  )
}

export { DailyMetricFillSelector }
